module.exports = __webpack_public_path__ + "img/setting_btn.d3621bf8.png";